// mediaManagment

import { Document }  from '../documentManagment/types';

export interface Media
 {
  id                    : number      ,
  uuid                  : string      ,
  publicRef             : string      ,
  slug                  : string      ,     // Adresse lisible dans le portail public (kleon.tv/<slug>)
  creationDate          : Date | null ,
  creationIpAddress     : string      ,     // IP du poste ayant créé le média ("" si inconnue)
  mediaType             : string      ,     // Video ou Image ...
  name                  : string      ,     // Copie de title     => pour affichage dans selecteur...
  thumbnail             : string      ,     // Copie de imageFile => pour affichage dans selecteur...
  originalFile          : string      ,     // Nom du fichier tel que téléversé ("IMG_4471.JPG"), sans le chemin.
                                            // Sur le disque le média est renommé "M000123_<slug-du-titre>.ext" :
                                            // ce champ ne sert donc qu'à l'affichage, jamais à retrouver le fichier.
  comment               : string      ,
  state                 : number      ,     // -1 : pas transcodé , 0 : transcodé mais non actif , 1 : transcodé et actif

  active                : boolean     ,     
  activeScheduled       : boolean     ,     
  activeStartDate       : Date | null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
  activeEndDate         : Date | null ,     // Si non nul alors actif après cette date, sinon actif/inactif immédiatement
  transcoded            : boolean     ,     
  publicPortal          : boolean     ,     // Présent sur le portail public
  automaticPlaylist     : boolean     ,     // Éligible à la programmation automatique (vidéos)
  multiview            ?: boolean     ,     // Vidéo publiée avec ses angles

  requiredUserStatusId  : number      ,     // Id du statut que doit avoir le user 
  categoriesIds         : number []   ,
  keywordsIds           : number []   ,
  associatedProductIds  : number []   ,     // Pour les ventes de media ( 0 : prix de ventes à l'unité , 1.... : prix de la location
  associatedProductId   : number      ,     // A virer
  mediaDocuments        : Document[]  ,
  hasSalesCampaign      ?: boolean    ,     // Video/AudioSlideshow uniquement : a au moins une SalesAction associée

  // Place occupée sur le disque par le média, en octets — répertoire complet,
  // tous rendus HLS compris. Mesurée par le serveur, jamais estimée ici.
  // `storageComputedAt` à null signifie « jamais mesuré » : sans lui, un 0 ne
  // se distingue pas d'un média réellement vide.
  storageBytes          : number      ,
  storageOriginBytes   ?: number      ,     // Vidéo multiview : part des enregistrements d'origine dans storageBytes
  storageComputedAt     : Date | null ,
 }

 export interface MediaCategory
 {
  id            : number  ,
  name          : string  ,
  rank          : number  ,
  visible       : boolean ,
  mediaType     : string  ,
 }

export const initializedMedia = (): Media => (
 {
  id                   : 0     ,
  uuid                 : ""    ,
  publicRef            : ""    ,
  slug                 : ""    ,
  creationDate         : null  ,
  creationIpAddress    : ""    ,
  mediaType            : ""    ,
  name                 : ""    ,
  thumbnail            : ""    ,
  originalFile         : ""    ,
  comment              : ""    ,
  state                : -1    ,
  

  active               : false ,     
  activeScheduled      : false ,     
  activeStartDate      : null  ,
  activeEndDate        : null  ,
  transcoded           : false ,     
  publicPortal         : false ,     // Présent sur le portail public
  automaticPlaylist    : false ,

  requiredUserStatusId : 0     ,
  categoriesIds        : []    ,
  keywordsIds          : []    ,
  associatedProductIds : []    ,
  associatedProductId  : 0     ,
  mediaDocuments       : []    ,
  hasSalesCampaign     : false ,
  storageBytes         : 0     ,
  storageComputedAt    : null  ,
 });

export const initializedMediaCategory = (): MediaCategory => (
 {
  id            : 0     ,
  name          : ""    ,
  rank          : 0     ,
  visible       : false ,
  mediaType     : ''  ,
});

export const mediaTypeOptions : string [] = [
                                              '' ,
                                              'Image' ,
                                              'Son' ,
                                              'Vidéo' ,
                                              'Diaporama sonore'
                                            ];

export interface TranscodingState
 {
   mediaId           : number ,
   progress          : number ,
   timecodeInSeconds : number ,
   totalDuration     : number ,
   transcoded        : boolean
 }

export const initializedTranscodingState = (): TranscodingState => (
 {
   mediaId           : 0 ,
   progress          : 0 ,
   timecodeInSeconds : 0 ,
   totalDuration     : 0 ,
   transcoded        : false
});

/**
 * Ce que la suppression d'un média fera, tel que le serveur l'annonce avant le clic.
 *
 *  - 'refused'     : quelque chose a encore besoin du CONTENU du média — attendu à
 *                    l'antenne, rangé dans la médiathèque d'un spectateur, monté dans
 *                    un diaporama, vendu, dans une playlist. Rien ne sera touché.
 *  - 'record_kept' : les fichiers partent, la fiche reste pour ce qui la désigne
 *                    encore (diffusions passées, historique, commentaires, notes).
 *  - 'complete'    : fichiers et fiche partent ensemble.
 *
 * `details` est écrit pour être affiché tel quel, ligne à ligne, dans la fenêtre de
 * confirmation : ne pas le reformuler côté front, c'est le serveur qui sait.
 */
export interface MediaDeletionPlan
 {
   outcome   : 'refused' | 'record_kept' | 'complete' ,
   canDelete : boolean  ,
   summary   : string   ,
   details   : string[] ,
   reasons   : string[] ,
   message   : string   ,
   angleCount?: number      // Angles multiview supprimés avec la vidéo
 }
